import React, { createContext, useContext, useMemo, useReducer } from 'react';
import { useHistory } from 'react-router-dom';

import NavigationReducer, {
  POP_NAVIGATION_ACCOUNT,
  RESET_NAVIGATION_ACCOUNT,
  RESET_NAVIGATION_PAYMENTS,
  UPDATE_NAVIGATION_HISTORY,
} from './navigation.reducer';

export const NavigationContext = createContext<any>(null);

const initNavigation = {
  lastPath: '',
  navigationHistory: [
    {
      title: 'Inicio',
      url: '/dashboard',
    },
    {
      title: 'Cuenta',
      url: '/account',
    },
  ],
};

const moduleRootPaths = [
  '/main_payments',
  '/documentation',
  '/sinister',
  '/assistance',
  '/user-attention',
  '/user-faq',
];

const NavigationProvider = ({ ...props }) => {
  const [state, dispatch] = useReducer(NavigationReducer, initNavigation);
  let history = useHistory();

  // const getIncidents = async () => {
  //   dispatch({
  //     type: REQUEST_INCIDENTS,
  //   });

  //   try {
  //     const res = await incidents();
  //     dispatch({
  //       type: SUCCESS_INCIDENTS,
  //       payload: res.data,
  //     });
  //   } catch (err) {
  //     dispatch({
  //       type: FAILURE_INCIDENTS,
  //     });
  //   }
  // };

  const updateNavigation = async (navigator) => {
    history.push(navigator.url);
    dispatch({
      type: UPDATE_NAVIGATION_HISTORY,
      payload: {
        title: navigator.title,
        url: navigator.url,
      },
    });
  };

  const resetNavigationAccount = () => {
    dispatch({
      type: RESET_NAVIGATION_ACCOUNT,
    });
  };

  const resetNavigationPayments = () => {
    dispatch({
      type: RESET_NAVIGATION_PAYMENTS,
    });
  };

  const popNavigation = (location, path) => {
    dispatch({
      type: POP_NAVIGATION_ACCOUNT,
      payload: path,
    });
  };

  const isInModuleRoot = (pathname: string) => {
    return moduleRootPaths.includes(pathname);
  };

  const NavigationValue = useMemo(
    () => ({
      ...state,
      updateNavigation,
      resetNavigationAccount,
      popNavigation,
      resetNavigationPayments,
      isInModuleRoot,
    }),
    [state, updateNavigation]
  );

  return <NavigationContext.Provider value={NavigationValue} {...props} />;
};

export const useNavigationContext = () => useContext(NavigationContext);

export default NavigationProvider;
